import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  titles: {
    draft: 'Din bestilling (pris pr. måned)',
    main: 'Dit abonnement',
    billing_settings: 'Faktureringsindstillinger',
  },
  form: {
    billing_mode: {
      label: 'Faktureringsmåde',
    },
    has_trial: {
      label: 'Tilføj gratis prøvedage',
    },
    trial_days: {
      label: 'Hvor mange prøvedage skal der være?',
      placeholder: '21',
      validation: {
        required: 'Antal prøvedage er påkrævet',
        min: '{{value}} er minimumsværdien for prøvedage',
        max: '{{value}} er maksimumsværdien for prøvedage',
      },
    },
  },
  fields: {
    created_at: 'Oprettet den <strong>{{date}}</strong> af <strong>{{manager}}</strong>',
    updated_at: 'Sidst opdateret den <strong>{{date}}</strong> af <strong>{{manager}}</strong>',
    trial_ends_at: 'I prøveperiode indtil <strong>{{date}}</strong>',
    trial_days:
      '{{trialDays}} dages prøveperiode starter på lanceringsdatoen, du bliver opkrævet, når prøveperioden er slut',
    resumable_until: 'Kan genoptages indtil <strong>{{date}}</strong>',
    ended_at: 'Afsluttet den <strong>{{date}}</strong>',
    next_bill_at: 'Næste betaling den <strong>{{date}}</strong>',
    product: 'Produkt',
    quantity: 'Antal',
    price: 'Nettopris',
    tax: 'Moms',
    amount: 'Beløb',
    net: 'Netto',
    tax_percentage: 'Moms {{rate}}%',
    total: 'Samlet opkrævning pr. måned',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Opkrævning fra betalingsmetode',
    [BillingMode.InternalInvoicing]: 'Opkrævning fra salg',
  },
  labels: {
    included: 'inkluderet',
    sales_based_discount:
      'Der er en vare i kurven med variabel pris. Den faktiske pris beregnes ved oprettelse/opdatering af abonnementet på baggrund af sidste måneds salgstal',
  },
  buttons: {
    edit: 'Rediger',
    cancel: 'Opsig',
    resume: 'Genoptag',
  },
  modals: {
    cancel_subscription: {
      title: 'Opsig abonnementet for {{company}}?',
      description:
        'Dette opsiger det valgte abonnement, inklusive <strong>{{products}}</strong> (<strong>{{total}} i alt</strong>). Abonnementet kan stadig genoptages indtil <strong>{{billingAnchor}}</strong>, hvis kunden ombestemmer sig. Hvis abonnementet ikke genoptages inden da, skal der oprettes et nyt abonnement',
    },
    resume_subscription: {
      title: 'Genoptag abonnementet for {{company}}?',
      description:
        'Dette genoptager det valgte abonnement, inklusive <strong>{{products}}</strong>. Restauranten bliver opkrævet <strong>{{total}}</strong> hver måned fra og med <strong>{{billingAnchor}}</strong>',
    },
  },
  toasts: {
    cancel_subscription:
      'Hvis du vil opsige dit abonnement, bedes du kontakte din kontaktperson hos {{provider}} telefonisk eller via e-mail. Din kontaktperson opsiger abonnementet for dig med det samme.',
    failed_to_cancel_subscription: 'Noget gik galt under opsigelsen af abonnementet. Kontakt teknisk support',
    resume_subscription:
      'Hvis du vil genoptage dit abonnement, bedes du kontakte din kontaktperson hos {{provider}} telefonisk eller via e-mail. Din kontaktperson genoptager abonnementet for dig med det samme.',
    failed_to_resume_subscription: 'Noget gik galt under genoptagelsen af abonnementet. Kontakt teknisk support',
  },
};
